import type { FC } from 'react';
import { Container } from '@/DesignSystem/Component';
import HomePageSectionLessonHeader from './HomePageSectionLessonHeader';
import HomePageSectionLessonTab from './HomePageSectionLessonTab';
const HomePageSectionLesson: FC = () => {
  return <div className="bg-blackOne lg:py-6" data-sentry-component="HomePageSectionLesson" data-sentry-source-file="HomePageSectionLesson.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="HomePageSectionLesson.tsx">
        <HomePageSectionLessonHeader data-sentry-element="HomePageSectionLessonHeader" data-sentry-source-file="HomePageSectionLesson.tsx" />
        <HomePageSectionLessonTab data-sentry-element="HomePageSectionLessonTab" data-sentry-source-file="HomePageSectionLesson.tsx" />
      </Container>
    </div>;
};
export default HomePageSectionLesson;